<template>
    <section class="accessibility-info">
        <div class="container">
            <div class="grid grid--xlarge">
                <div class="grid__item lap-and-up-one-third">
                    <div class="accessibility-info__heading">
                        <BaseIcon
                            icon="accessibility-badge-dt"
                        >
                        </BaseIcon>

                        <h3 class="accessibility-info__title">Accessibility</h3>
                    </div>
                    
                    <figure v-if="image" class="accessibility-info__image">
                        <img :srcset="image" :alt="imageCaption">

                        <figcaption 
                            v-if="imageCaption"
                            class="accessibility-info__caption"
                        >{{ imageCaption }}</figcaption>
                    </figure>
                </div>

                <div class="grid__item lap-and-up-two-thirds mt-small">
                    <BaseText
                        :text="text"
                    />
                </div>
            </div>
        </div>
    </section>
</template>
<script>

export default {
    name: 'accessibility-info',
    props: {
        text: {
            type: String,
            required: true,
        },
        image: {
            type: String,
            required: false
        },
        imageCaption: {
            type: String,
            required: false,
        }
    }
}
</script>
<style lang="scss" scoped>
    .accessibility-info {
        background-color: #ededed;
        color: #000;
        padding-top: getSpacing('medium');
        padding-bottom: getSpacing('large');
    }

    .accessibility-info__heading {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .BaseIcon {
            width: 50px;
            height: 50px;
            flex-shrink: 0;
            margin-right: 8px;
        }

        @include media-query('smart') {
            margin-bottom: getSpacing('medium');

            .BaseIcon {
                width: 38px;
                height: 38px;
            }
        }
    }

    .accessibility-info__title {
        font-family: $heading-font-family;
        text-transform: uppercase;
        font-size: 36px;

        @include media-query(lap) {
            font-size: 32px;
        }

        @include media-query(smart) {
            font-size: 24px;
        }
    }

    .accessibility-info__caption {
        font-weight: bold;
        text-transform: uppercase;
        font-size: 0.75em;
        margin-top: getSpacing('medium');
        margin-bottom: getSpacing('medium');

        @include media-query('smart') {
            margin-top: getSpacing('base');       
        }
    }

    .accessibility-info__image {
        margin-top: getSpacing('large');
    }

    .BaseText {
        .wysiwyg {
            color: #000;
            p {
                line-height: 1.4;
                letter-spacing: -0.5px;
            }
            
        }
    }
</style>
